import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

export const REPORT_LINK_INVALID = 'Enlace de descarga inválido';
export const REPORT_LINK_NOT_FOUND = 'El reporte no existe o ya no está disponible';
export const REPORT_LINK_NOT_READY = 'El reporte aún no está listo';
export const REPORT_LINK_FAILED = 'No se pudo generar el reporte';
export const REPORT_LINK_UNAVAILABLE = 'No pudimos obtener la descarga; intenta de nuevo';

export interface ReportLinkNotice {
  tone: 'error' | 'warning';
  message: string;
}

export function reportLinkDownloadNotice(cause: unknown): ReportLinkNotice | null {
  if (!(cause instanceof HttpErrorResponse)) {
    return { tone: 'error', message: REPORT_LINK_UNAVAILABLE };
  }
  if (cause.status === HttpStatusCode.Unauthorized) return null;
  if (cause.status === HttpStatusCode.BadRequest) {
    return { tone: 'error', message: REPORT_LINK_INVALID };
  }
  if (cause.status === HttpStatusCode.NotFound) {
    return { tone: 'error', message: REPORT_LINK_NOT_FOUND };
  }
  if (cause.status === HttpStatusCode.Conflict) {
    return failureStatus(cause) === 'FAILED'
      ? { tone: 'error', message: REPORT_LINK_FAILED }
      : { tone: 'warning', message: REPORT_LINK_NOT_READY };
  }
  return { tone: 'error', message: REPORT_LINK_UNAVAILABLE };
}

function failureStatus(cause: HttpErrorResponse): string | undefined {
  const details = (cause.error as { error?: { details?: unknown } } | null)?.error?.details;
  if (!details || Array.isArray(details) || typeof details !== 'object') return undefined;
  const status = (details as { status?: unknown }).status;
  return typeof status === 'string' ? status : undefined;
}
